import { TypeAhead } from "@/types/typeAhead";
import { Column } from "@/components/ui/organisms/DataTableDocument";

export const typeAheadTableConfig = {
  columns: [
    {
      key: "category" as keyof TypeAhead,
      label: "Category Name",
      sortable: true,
    },

    { key: "values" as keyof TypeAhead, label: "Values", sortable: true },

    {
      key: "reviewValues" as keyof TypeAhead,
      label: "Review Values",
      sortable: true,
    },
  ] as Column<TypeAhead>[],

  filters: [
    {
      key: "category",
      label: "Category Name",
      type: "text" as const,
      placeholder: "Search by category...",
      default: true,
    },
    {
      key: "values",
      label: "Values",
      type: "text" as const,
      placeholder: "Search by values...",
    },
  ],
};

export const filterKeyToConfigMap = typeAheadTableConfig.filters.reduce(
  (acc, filter) => {
    acc[filter.key] = filter.type;
    return acc;
  },
  {} as Record<string, "text" | "select">
);

export const editableKeysAdd: (keyof TypeAhead)[] = ["category", "values"];

export const editableKeysEdit: (keyof TypeAhead)[] = ["values", "reviewValues"];

export const editableFieldsAdd = typeAheadTableConfig.columns.filter((col) =>
  editableKeysAdd.includes(col.key)
);

export const editableFieldsEdit = typeAheadTableConfig.columns.filter((col) =>
  editableKeysEdit.includes(col.key)
);
